import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { IconButton, Pane, Spinner } from 'evergreen-ui';
import React, { Dispatch, useCallback } from 'react';

import { RelayPageInfo } from '../../common';
import { RelayPaginationActionPayload } from './action';

export enum RelayPaginationNav {
    FIRST_PAGE,
    PREV_PAGE,
    NEXT_PAGE,
    LAST_PAGE
}

type Props = {
    pageInfo?: RelayPageInfo;
    count?: number;
    onClick: (action: RelayPaginationNav) => void;
}

export function useRelayPagination(dispatch: Dispatch<RelayPaginationActionPayload>, count?: number) {
    const onPaginationClick = useCallback(
        (nav: RelayPaginationNav) => dispatch({ type: 'RELAY_PAGINATION_ACTION', paginationNav: nav, count }),
        [dispatch, count]
    );
    return {
        onPaginationClick
    };
}

const defaultPageInfo: RelayPageInfo = {
    hasPreviousPage: false,
    endCursor: '0',
    hasNextPage: false,
    startCursor: '0'
};
export function RelayPagination({ pageInfo = defaultPageInfo, count, onClick }: Props) {
    const onFirst = useCallback(
        (e: MouseEvent) => onClick(RelayPaginationNav.FIRST_PAGE),
        [onClick]
    );

    const onPrev = useCallback(
        (e: MouseEvent) => onClick(RelayPaginationNav.PREV_PAGE),
        [onClick]
    );

    const onNext = useCallback(
        (e: MouseEvent) => onClick(RelayPaginationNav.NEXT_PAGE),
        [onClick]
    );

    const onLast = useCallback(
        (e: MouseEvent) => onClick(RelayPaginationNav.LAST_PAGE),
        [onClick]
    );

    const startCursor = pageInfo?.startCursor || 0;
    const endCursor = pageInfo?.endCursor || 0;

    return (
        <Pane display="flex" alignItems="center" className="px-5">
            <div className="pr-5">
                {count != null ? (
                    `${ startCursor }-${ endCursor } of ${ count }`
                ) : (
                    <Spinner size={ 24 }/>
                )}
            </div>
            <IconButton iconBefore={ FirstPageIcon }
                        appearance="minimal"
                        disabled={ !pageInfo.hasPreviousPage }
                        className="portal-ev-black"
                // @ts-ignore
                        onClick={ onFirst }
            />
            <IconButton iconBefore={ NavigateBeforeIcon }
                        appearance="minimal" disabled={ !pageInfo.hasPreviousPage }
                        className="portal-ev-black"
                // @ts-ignore
                        onClick={ onPrev }
            />
            <IconButton iconBefore={ NavigateNextIcon }
                        appearance="minimal" disabled={ !pageInfo.hasNextPage }
                        className="portal-ev-black"
                // @ts-ignore
                        onClick={ onNext }
            />
            <IconButton iconBefore={ LastPageIcon }
                        appearance="minimal" disabled={ !pageInfo.hasNextPage }
                        className="portal-ev-black"
                // @ts-ignore
                        onClick={ onLast }
            />
        </Pane>
    );
}
